import { View } from "binder"
import { MachineModelManipulationViewModel, MachineModel } from "./machineModelManipulation-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class MachineModelManipulationView extends View<MachineModelManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-54003548-AD27-4044-8CFF-BEA38AC106D9"
    }
    loadHtml(): string {
        let element = require('./machineModelManipulation.html').default;
        let style = require('./machineModelManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set machineModels(v: MachineModel) { this._machineModels = v; } public get machineModels(): MachineModel { return this._machineModels; } private _machineModels: MachineModel;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    addNew() {
        this.dataContext.addNew();
    }
}
